import React from 'react'
import { Link } from 'react-router'

const LinkHandler = ({ onClick, to, ...props }) => {
  const isButton = () => !to && onClick
  const isExternalLink = () => to && /^((ftp|http|https):\/\/)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/.test(to)
  const isMailtoLink = () => to && to.indexOf('mailto') === 0

  if (isButton()) {
    return <button onClick={onClick} {...props} />
  }

  if (isExternalLink()) {
    return <a {...props} href={to} target='_blank' />
  }

  if (isMailtoLink()) {
    return <a href={to} {...props} />
  }

  return <Link onClick={onClick} to={to} {...props} />
}

export default LinkHandler



// WEBPACK FOOTER //
// ./components/utils/LinkHandler/index.js